import { TrelloWindow } from '@trello/window-types';

import { getSupportedLocales } from './getSupportedLocales';

declare const window: TrelloWindow;

const loaders: { [key: string]: Promise<void> } = {};

export async function loadLocaleBundle(locale: string) {
  if (locale in loaders) {
    return loaders[locale];
  }

  if (!getSupportedLocales().includes(locale)) {
    throw new Error('Locale not supported');
  }

  loaders[locale] = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.onerror = () => {
      reject(new Error('Could not load locale bundle'));
    };

    script.onload = () => {
      resolve();
    };

    document.head.appendChild(script);
    script.src = window.__localeBundles[`locale.${locale}`];
  });

  return loaders[locale];
}
